import React from "react";

/**
 * A task's start or completion time in a history table: the time to the
 * second, with the date beneath — the same cell game history uses, so the two
 * read alike.
 */
const TimeCell = ({ value, empty = "—" }) => {
  const d = value ? new Date(value) : null;
  if (!d || isNaN(d.getTime())) return <span className="text-xs text-gray-400 whitespace-nowrap">{empty}</span>;
  return (
    <>
      <p className="text-gray-700 tabular-nums whitespace-nowrap">
        {d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })}
      </p>
      <p className="text-[11px] text-gray-400 whitespace-nowrap">
        {d.toLocaleDateString("en-US", { day: "2-digit", month: "short", year: "numeric" })}
      </p>
    </>
  );
};

export default TimeCell;
